



















































import Vue from 'vue';
import { Button, Icon, HeroImage } from '@descomplica/vue-components';
import { getAssetPath } from '@/helpers/assets';
import i18n from '@/i18n';

export default Vue.extend({
  components: { HeroImage, Button, Icon },
  props: {
    success: { type: Boolean, required: true },
    retry: { type: Boolean, required: true },
    userFirstName: { type: String, required: true },
  },
  data() {
    return {
      backgroundSrc: getAssetPath('img/BackgroundImage.svg'),
      maskUrl: getAssetPath('img/mask.svg'),
    };
  },
  computed: {
    iconSrc(): string {
      if (this.success) return getAssetPath('img/freshmanLife.svg');

      if (this.retry) return getAssetPath('img/vish.svg');

      return getAssetPath('img/fail.svg');
    },
    imgSrc(): string {
      if (this.success) return getAssetPath('img/hero/success.jpg');

      if (this.retry) return getAssetPath('img/hero/retry.jpg');

      return getAssetPath('img/hero/fail.jpg');
    },
    hasBackground(): boolean {
      return this.success;
    },
    subtitle(): string {
      if (this.success) return i18n.t('result.secondGradAndTransfer.successSubtitle');

      if (this.retry) return i18n.t('result.secondGradAndTransfer.retrySubtitle');

      return '';
    },
    title(): string {
      const name = this.userFirstName;

      if (this.success) return i18n.t('result.secondGradAndTransfer.successTitle', { name });

      if (this.retry) return i18n.t('result.secondGradAndTransfer.retryTitle', { name });

      return i18n.t('result.secondGradAndTransfer.failTitle', { name });
    },
  },
  methods: {
    goToHome() {
      window.location.replace('https://descomplica.com.br/faculdade/');
    },
  },
});
